import { ArrowRight, ChevronRight, ShieldCheck, MapPin, Headphones, BadgeCheck } from "lucide-react";

const HERO_IMG = "/brand/hero-fleet.jpg";

export default function Hero() {
  return (
    <section id="home" className="relative min-h-[100vh] flex items-end overflow-hidden" data-testid="hero-section">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Rydey corporate fleet — Innova Crysta SUVs and Tempo Traveller with uniformed drivers in Kerala"
          className="w-full h-full object-cover"
          style={{ objectPosition: "center 55%" }}
          loading="eager"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(100deg, rgba(8,17,50,0.92) 0%, rgba(13,27,64,0.78) 38%, rgba(13,27,64,0.30) 70%, rgba(8,17,50,0.55) 100%)",
          }}
        />
        <div
          className="absolute inset-x-0 bottom-0 h-44"
          style={{
            background:
              "linear-gradient(180deg, rgba(8,17,50,0) 0%, rgba(8,17,50,0.85) 80%, rgba(8,17,50,0.95) 100%)",
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(60% 50% at 80% 20%, rgba(245,166,35,0.12) 0%, rgba(245,166,35,0) 60%)",
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-5 md:px-8 pt-32 md:pt-40 pb-10">
          <div className="max-w-3xl">
            <div className="eyebrow text-[#F5A623] mb-5 fade-in" style={{ animationDelay: "0.1s" }}>
              All Day · Everyday
            </div>
            <h1
              className="text-white font-extrabold tracking-tight text-[40px] sm:text-[52px] md:text-[64px] leading-[1.05] fade-up"
              style={{ animationDelay: "0.18s" }}
              data-testid="hero-headline"
            >
              South India's Most Trusted{" "}
              <span className="text-[#F5A623]">Corporate Transportation</span> Partner
            </h1>
            <p
              className="mt-6 text-white/85 text-[17px] md:text-[19px] leading-relaxed max-w-2xl fade-up"
              style={{ animationDelay: "0.32s" }}
              data-testid="hero-subheadline"
            >
              Safe, technology-powered employee commute solutions across
              Thiruvananthapuram, Chennai, Coimbatore, Kochi & Bengaluru.
            </p>

            <div
              className="mt-9 flex flex-col sm:flex-row gap-4 fade-up"
              style={{ animationDelay: "0.46s" }}
            >
              <a href="#contact" className="btn-primary pulse-gold" data-testid="hero-cta-quote">
                Get a Quote <ArrowRight size={18} />
              </a>
              <a href="#services" className="btn-secondary" data-testid="hero-cta-how">
                Explore Our Services <ChevronRight size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Trust bar */}
        <div className="bg-[#081132]/80 backdrop-blur-sm border-t border-white/10">
          <div className="max-w-7xl mx-auto px-5 md:px-8 py-5">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6" data-testid="hero-trust-bar">
              <TrustItem icon={<MapPin size={18} />} text="GPS Tracked Vehicles" />
              <TrustItem icon={<ShieldCheck size={18} />} text="Police Verified Drivers" />
              <TrustItem icon={<Headphones size={18} />} text="24/7 Support" />
              <TrustItem icon={<BadgeCheck size={18} />} text="100% Reliability Guaranteed" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function TrustItem({ icon, text }) {
  return (
    <div className="flex items-center gap-3 text-white/90">
      <span className="text-[#F5A623]">{icon}</span>
      <span className="text-[13px] md:text-[14px] font-medium tracking-wide">{text}</span>
    </div>
  );
}
